module.exports = __webpack_public_path__ + "img/logo-header.00989981.png";